(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ww-oyster-101"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ww-o101').forEach((section) => {
  const content = section.querySelector('.ww-o101__content');
  const lead = section.querySelector('.ww-o101__lead');
  if (!content) return;

  const firstImage = content.querySelector('img');
  if (lead && firstImage) {
    const clone = firstImage.cloneNode(true);
    clone.removeAttribute('width');
    clone.removeAttribute('height');
    lead.appendChild(clone);
    lead.classList.add('has-image');
    const wrapper = firstImage.closest('p, div');
    if (wrapper && wrapper.textContent.trim() === '') wrapper.remove();
    else firstImage.remove();
  }

  const nodes = Array.from(content.childNodes);
  const intro = document.createElement('div');
  intro.className = 'ww-o101__intro';
  let activeChapter = null;
  let chapterBody = null;
  let chapterIndex = 0;

  nodes.forEach((node) => {
    if (node.nodeType === 1 && node.tagName === 'H2') {
      chapterIndex += 1;
      activeChapter = document.createElement('section');
      activeChapter.className = 'ww-o101__chapter';
      const rail = document.createElement('div');
      rail.className = 'ww-o101__chapter-rail';
      const num = document.createElement('span');
      num.className = 'ww-o101__chapter-num';
      num.textContent = String(chapterIndex).padStart(2, '0');
      rail.appendChild(num);
      rail.appendChild(node);
      chapterBody = document.createElement('div');
      chapterBody.className = 'ww-o101__chapter-body';
      activeChapter.appendChild(rail);
      activeChapter.appendChild(chapterBody);
      content.appendChild(activeChapter);
    } else if (activeChapter && chapterBody) {
      chapterBody.appendChild(node);
    } else {
      intro.appendChild(node);
    }
  });

  if (intro.textContent.trim() || intro.querySelector('img, table, ul, ol, blockquote')) {
    content.insertBefore(intro, content.firstChild);
  }

  content.querySelectorAll('.ww-o101__chapter').forEach((chapter) => {
    if (chapter.querySelector('img, iframe, video')) chapter.classList.add('has-media');
  });

  const jump = section.querySelector('.ww-o101__jump-links');
  content.querySelectorAll('.ww-o101__chapter h2').forEach((heading, index) => {
    if (!heading.id) heading.id = 'section-' + (index + 1);
    if (jump && index < 8) {
      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      jump.appendChild(link);
    }
  });

  const jumpWrap = section.querySelector('.ww-o101__jump');
  if (jump && jump.children.length === 0 && jumpWrap) jumpWrap.remove();
});

  } catch(e) { console.error(e); }
})();
})();
